import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from "@angular/core";
import { CommonFieldManagerDirective, FIELD_TOKEN } from "../../field-manager.directive";
import { FieldStateService } from "../../field-state.service";
import { SwitchStateService } from "./switch-state.service";

@Component({
    selector: "common-switch",
    templateUrl: "./common-switch.component.html",
    exportAs: "CommonSwitch",
    providers: [
        CommonFieldManagerDirective,
        { provide: FieldStateService, useClass: SwitchStateService },
        { provide: FIELD_TOKEN, useValue: "commonFormSwitchs" },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommonSwitchComponent {
    public fieldValue: boolean;
    @Input() public onLabel = "Yes";
    @Input() public offLabel = "No";
    @Input() public fieldIsDisabled = false;

    @HostBinding("class.u-display-flex") public isFlex = true;

    constructor(
        public fieldManager: CommonFieldManagerDirective,
        public fieldStateService: FieldStateService,
        public changeDetectorRef: ChangeDetectorRef,
    ) {
        this.fieldManager.fieldDefault = false;
        this.fieldManager.syncDefaultValues();
    }

    public get modelValue() {
        return this.fieldManager.fieldValue;
    }

    public get isNormalSwitch() {
        return this.fieldManager.fieldType === "switch";
    }

    public get isCheckboxSwitch() {
        return this.fieldManager.fieldType === "checkboxSwitch";
    }
}
